import BatchButton from './src/main'

BatchButton.install = function (Vue) {
    Vue.component(BatchButton.name, BatchButton)
}

export default BatchButton